import { useCallback } from "react";
import { AttributeDistinctsDc } from "@evergis/api";
import { useEvergisContext } from "@evergis/react";
import { IOption } from "@evergis/ui";
import { Char } from "@evergis/condition";

import { unEscapeAttributeValue } from "../../../modules/FeatureCard/hooks/useFeatureAttributes";

const OPTIONS_LIMIT = 10;

const createTextOption = (text: string): IOption => ({ value: text, text });

const optionsFromDistincts = (attributeDistincts: AttributeDistinctsDc): IOption[] => {
  return attributeDistincts.distincts.map(({ value }) => createTextOption(unEscapeAttributeValue(value)));
};

export const useGetValueOptions = (
  layerName: string,
  attribute: string,
): ((startsWith: string) => Promise<IOption[]>) => {
  const { layers } = useEvergisContext();

  return useCallback(
    async (startsWith: string) => {
      if (startsWith) {
        return layers
          .distincts({
            name: layerName,
            attribute,
            startsWith: Char.escapeSpecChars(startsWith),
            limit: OPTIONS_LIMIT,
            ignoreDefaultCondition: true,
          })
          .then(optionsFromDistincts);
      }

      return Promise.resolve([]);
    },
    [layers, attribute, layerName],
  );
};
